"use strict";

angular.module("customer")
.directive("iconIncompleteProfile", function($rootScope) {
    return {
        restrict: "AE",
        scope: {
            action: "="
        },
        templateUrl: require("./icon-incomplete-profile.directive.html"),
        controller: function($scope, $attrs, UserService) {
            $scope.iconDisplayWarning = false;

            function updateIconWarning(user) {
                if (user && user.has_profile_completed) {
                    if ($attrs.action === "profile") {
                        $scope.iconDisplayWarning = !user.has_profile_completed["profile"];
                    }
                    else if ($attrs.action === "customer") {
                        $scope.iconDisplayWarning = !user.has_profile_completed["customer"];
                    }
                    else {
                        $scope.iconDisplayWarning = !user.has_profile_completed["all"];
                    }
                }
            }

            UserService.isUserFetched().then(function onSuccess(user) {
                updateIconWarning(user);
            });

            $scope.$on("UserUpdated", function(event, user) {
                updateIconWarning(user);
            });

            $scope.$on("UserLoggedOut", function(event, user) {
                $scope.iconDisplayWarning = false;
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/full-profile-only/icon-incomplete-profile.directive.js
// module id = 830
// module chunks = 0